import i18n from '@/js/vue-i18n';
import promotionDateRangeUtils from '@sharedModules/promotion-date-range-utils';
import { toSentenceCase } from '../utils/string-utils';

const { getPromotionDateRangeError, promotionDateRangeErrors } = promotionDateRangeUtils;

const errorMessageKeys = {
    [promotionDateRangeErrors.outsideScenario]: 'validation.promotionDates.outsideScenario',
    [promotionDateRangeErrors.noScenarioOverlap]: 'validation.promotionDates.noScenarioOverlap',
    [promotionDateRangeErrors.tooFarFromScenario]: 'validation.promotionDates.tooFarFromScenario',
};

/**
 * Validates the promotion dates against its scenario dates.
 *
 * @param {String} value - The displayed date range (unused, dates are read via getPromotionDates).
 * @param {String} message - Optional override for the error message.
 * @param {Function} getPromotionDates - Returns the current { startDate, endDate } of the promotion.
 * @param {Function} getScenario - Returns the scenario with startDate and endDate.
 * @param {Object} options - { allowOutsideScenario, maxDaysOutsideScenario }.
 * @returns {Boolean|String} - true when valid, otherwise the error message.
 */
const promotionDatesWithinScenario = (
    value,
    message,
    getPromotionDates,
    getScenario,
    { allowOutsideScenario = false, maxDaysOutsideScenario } = {}
) => {
    const error = getPromotionDateRangeError({
        promotion: getPromotionDates(),
        scenario: getScenario(),
        allowOutsideScenario,
        maxDaysOutsideScenario,
    });

    if (!error) {
        return true;
    }

    return message || toSentenceCase(i18n.t(errorMessageKeys[error], { maxDaysOutsideScenario }));
};

export default promotionDatesWithinScenario;
